import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Courses from "@/components/site/Courses";
import Gallery from "@/components/site/Gallery";
import Benefits from "@/components/site/Benefits";
import Testimonials from "@/components/site/Testimonials";
import CTA from "@/components/site/CTA";
import Footer from "@/components/site/Footer";
import WhatsAppFAB from "@/components/site/WhatsAppFAB";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white text-[#0a0a0a]">
      <Navbar />
      <main>
        <Hero />
        <Courses />
        <Gallery />
        <Benefits />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
